





















import { Vue, Component, Prop } from "vue-property-decorator";
import * as user from "../../_store/user.module";
import * as data from "../../_store/data.module";
import * as images from "../../assets/images";
import { DocConvenzione } from "../../_models/docConvenzione";
import { bus } from "../../main";

//@ts-ignore
import * as pdfMake from "pdfmake/build/pdfmake";
//@ts-ignore
import * as pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component
export default class ConvenzioneAlternanzaReview extends Vue {
  @Prop() docInfo!: DocConvenzione;
  private ruoloUtente: number[];
  private tipoAttivita: string;

  private elements: DocConvenzione;

  private doc: any;

  constructor() {
    super();
    this.ruoloUtente = [];
    this.tipoAttivita = "";
    this.elements = {
      idConvenzione: this.docInfo.idConvenzione,
      denominazioneIstituto: this.docInfo.denominazioneIstituto,
      indirizzoIstituto: this.docInfo.indirizzoIstituto,
      capIstituto: this.docInfo.capIstituto,
      comuneIstituto: this.docInfo.comuneIstituto,
      provinciaIstituto: this.docInfo.provinciaIstituto,
      telefonoIstituto: this.docInfo.telefonoIstituto,
      emailIstituto: this.docInfo.emailIstituto,
      codiceFiscaleIstituto: this.docInfo.codiceFiscaleIstituto,
      dirigenteIstituto: this.docInfo.dirigenteIstituto,
      luogoNascitaDirigenteIstituto: this.docInfo.luogoNascitaDirigenteIstituto,
      dataNascitaDirigenteIstituto: this.docInfo.dataNascitaDirigenteIstituto,
      denominazioneAzienda: this.docInfo.denominazioneAzienda,
      indirizzoAzienda: this.docInfo.indirizzoAzienda,
      capAzienda: this.docInfo.capAzienda,
      comuneAzienda: this.docInfo.comuneAzienda,
      provinciaAzienda: this.docInfo.provinciaAzienda,
      telefonoAzienda: this.docInfo.telefonoAzienda,
      emailAzienda: this.docInfo.emailAzienda,
      pecAzienda: this.docInfo.pecAzienda,
      pIvaAzienda: this.docInfo.pIvaAzienda,
      rappresentanteAzienda: this.docInfo.rappresentanteAzienda,
      luogoNascitaRappresentanteAzienda: this.docInfo.luogoNascitaRappresentanteAzienda,
      dataNascitaRappresentante: this.docInfo.dataNascitaRappresentante,
      dataDocumento: this.docInfo.dataDocumento,
      idStatoDoc: this.docInfo.idStatoDoc,
      firmaAzienda: this.docInfo.firmaAzienda,
      firmaIstituto: this.docInfo.firmaIstituto,
      tipoAttivita: this.docInfo.tipoAttivita,
      numeroProtocollo: this.docInfo.numeroProtocollo,
      idTemplate: this.docInfo.idTemplate,
      codAteco: this.docInfo.codAteco,
      codIstat: this.docInfo.codIstat,
      indirizzoTirocinio: this.docInfo.indirizzoTirocinio,
      comuneTirocinio: this.docInfo.comuneTirocinio,
      provinciaTirocinio: this.docInfo.provinciaTirocinio,
      tutorAziendale: this.docInfo.tutorAziendale,
      tutorFormativo: this.docInfo.tutorFormativo,
      tutorArticolazione: this.docInfo.tutorArticolazione
    };
    this.doc = null;
  }

  createDoc() {
    if (this.elements.firmaAzienda === null) {
      this.elements.firmaAzienda = images.noFirma;
    }

    var finalDocStr: string = this.completeDoc();
    var json = JSON.parse(finalDocStr);

    const pdfDocGenerator = pdfMake.createPdf(json);
    // const pdfDocGenerator = pdfMake.createPdf(dd);
    pdfDocGenerator.getDataUrl(function (dataUrl: any) {
      const targetElement = document.querySelector("#iframeContainer");
      const embed = document.createElement("embed");
      embed.src = dataUrl;
      embed.width = "1000";
      embed.height = "700";
      if (targetElement !== null) {
        targetElement.appendChild(embed);
      }
    });
  }

  completeDoc(): string {
    var completeDoc: string = "";
    completeDoc = JSON.stringify(this.doc);
    completeDoc = completeDoc.replace(/%%_header_%%/g, images.authHeader);
    completeDoc = completeDoc.replace(/%%_footer_%%/g, images.authFooter);
    completeDoc = completeDoc.replace(/%%_headerDocVallauri_%%/g, images.headerDocVallauri);
    completeDoc = completeDoc.replace(/%%_footerDocVallauri_%%/g, images.footerDocVallauri);
    completeDoc = completeDoc.replace(
      /%%_denominazioneIstituto_%%/g,
      this.elements.denominazioneIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_indirizzoIstituto_%%/g,
      this.elements.indirizzoIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_capIstituto_%%/g,
      this.elements.capIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_comuneIstituto_%%/g,
      this.elements.comuneIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_provinciaIstituto_%%/g,
      this.elements.provinciaIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_telefonoIstituto_%%/g,
      this.elements.telefonoIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_emailIstituto_%%/g,
      this.elements.emailIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_codiceFiscaleIstituto_%%/g,
      this.elements.codiceFiscaleIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_dirigenteIstituto_%%/g,
      this.elements.dirigenteIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_luogoNascitaDirigenteIstituto_%%/g,
      this.elements.luogoNascitaDirigenteIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_dataNascitaDirigenteIstituto_%%/g,
      this.elements.dataNascitaDirigenteIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_denominazioneAzienda_%%/g,
      this.elements.denominazioneAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_indirizzoAzienda_%%/g,
      this.elements.indirizzoAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_capAzienda_%%/g,
      this.elements.capAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_comuneAzienda_%%/g,
      this.elements.comuneAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_provinciaAzienda_%%/g,
      this.elements.provinciaAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_telefonoAzienda_%%/g,
      this.elements.telefonoAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_emailAzienda_%%/g,
      this.elements.emailAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_pecAzienda_%%/g,
      this.elements.pecAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_pIvaAzienda_%%/g,
      this.elements.pIvaAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_rappresentanteAzienda_%%/g,
      this.elements.rappresentanteAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_luogoNascitaRappresentanteAzienda_%%/g,
      this.elements.luogoNascitaRappresentanteAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_dataNascitaRappresentante_%%/g,
      this.elements.dataNascitaRappresentante
    );
    completeDoc = completeDoc.replace(
      /%%_dataDocumento_%%/g,
      this.elements.dataDocumento
    );
    completeDoc = completeDoc.replace(
      /%%_firmaAzienda_%%/g,
      this.elements.firmaAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_firmaIstituto_%%/g,
      this.elements.firmaIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_tipoAttivita_%%/g,
      this.elements.tipoAttivita
    );
    completeDoc = completeDoc.replace(
      /%%_numeroProtocollo_%%/g,
      this.elements.numeroProtocollo
    );
    completeDoc = completeDoc.replace(
      /%%_codAteco_%%/g,
      this.elements.codAteco
    );
    completeDoc = completeDoc.replace(
      /%%_codIstat_%%/g,
      this.elements.codIstat
    );
    completeDoc = completeDoc.replace(
      /%%_indirizzoTirocinio_%%/g,
      this.elements.indirizzoTirocinio
    );
    completeDoc = completeDoc.replace(
      /%%_comuneTirocinio_%%/g,
      this.elements.comuneTirocinio
    );
    completeDoc = completeDoc.replace(
      /%%_provinciaTirocinio_%%/g,
      this.elements.provinciaTirocinio
    );
    completeDoc = completeDoc.replace(
      /%%_tutorFormativo_%%/g,
      this.elements.tutorFormativo
    );
    completeDoc = completeDoc.replace(
      /%%_tutorAziendale_%%/g,
      this.elements.tutorAziendale
    );
    completeDoc = completeDoc.replace(
      /%%_tutorArticolazione_%%/g,
      this.elements.tutorArticolazione
    );
    completeDoc = completeDoc.replace(
      /%%_tutorArticolazione_%%/g,
      this.elements.tutorArticolazione
    );

    return completeDoc;
  }

  confirm() {
    var payload = {
      idConvenzione: this.elements.idConvenzione
    };
    if (this.elements.firmaAzienda !== null) {
      user
        .dispatchConfirmConvenzione(this["$store"], payload)
        .then(() => {
          this.close();
          bus.$emit("loadPreAssegnazioni");
          bus.$emit(
            "successfullOperation",
            "Convenzione accettata con successo"
          );
        })
        .catch(error => {
          if (error.response.status === 403) {
            bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
            this["$router"].push("/login");
          } else {
            bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          }
        });
    } else {
      bus.$emit(
        "errorOperation",
        "Impossibile accettare documento. Firma Azienda mancante"
      );
    }
  }
  refuse() {
    var payload = {
      idConvenzione: this.elements.idConvenzione
    };
    if (this.elements.firmaAzienda !== null) {
      user
        .dispatchRefuseConvenzione(this["$store"], payload)
        .then(() => {
          this.close();
          bus.$emit("loadPreAssegnazioni");
          bus.$emit(
            "successfullOperation",
            "Convenzione rifiutata con successo"
          );
        })
        .catch(error => {
          if (error.response.status === 403) {
            bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
            this["$router"].push("/login");
          } else {
            bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          }
        });
    } else {
      bus.$emit(
        "errorOperation",
        "Impossibile accettare documento. Firma Azienda mancante"
      );
    }
  }

  close() {
    bus.$emit("closeReview");
  }

  created() {
    // var userInfo = user.readUserInfo(this["$store"]);
    // if (userInfo === null) {
    //   userInfo = user.readStudentInfo(this["$store"]);
    // }
    // this.ruoloUtente = userInfo.ruoloUtente;
    // this.createDoc();

    data
      .dispatchTemplateDoc(this["$store"], this.docInfo.idTemplate)
      .then(result => {
        this.doc = result;
        if (this.docInfo.tipoAttivita === "tirocinioReIns") {
          this.tipoAttivita = "tirocinio di inserimento/reinserimento";
        } else if (this.docInfo.tipoAttivita === "tirocinioFormativo") {
          this.tipoAttivita = "tirocinio formativo e di orientamento";
        }
        var userInfo = user.readUserInfo(this["$store"]);
        if (userInfo === null) {
          userInfo = user.readStudentInfo(this["$store"]);
        }
        this.ruoloUtente = userInfo.ruoloUtente;
        this.createDoc();
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
        }
      });
  }
}
